import zipcelx from 'zipcelx';
import { now } from '@/infrastructure/date';

export const generateExcel = (data, options) => {
  if (!options.filename) {
    throw new Error('filename is required in options');
  }
  const keys = Object.keys(data[0]);
  const config = {
    filename: `${options.filename}_${now('DD-MM-YY-hh-MM')}`,
    sheet: {
      data: [keys.map(value => ({ value, type: 'string' }))]
    }
  };
  data.forEach(x => {
    const values = Object.values(x);
    const objects = values.map(value => ({ value, type: typeof value }));
    config.sheet.data.push(objects);
  });
  zipcelx(config);
};
